module.exports = __webpack_public_path__ + "img/tick_blue_success.04a7b363.svg";